import angular from "angular";
import { accountListFactory } from "./AccountList";
import { arrayCollectionFactory } from "./ArrayCollection";
import { autoIdListFactory } from "./AutoIDList";

export default angular
  .module('csm.books.InitialSetup.types', [])
  .factory('AccountList', accountListFactory)
  .factory('ArrayCollection', arrayCollectionFactory)
  .factory('AutoIDList', autoIdListFactory)
  .name;